// // components/SearchBar.tsx
// import React from "react";
// import { InputAdornment, TextField } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";

// interface SearchBarProps {
//   placeholder?: string;
//   value: string;
//   onChange: (value: string) => void;
// }

// const SearchBar: React.FC<SearchBarProps> = ({ placeholder, value, onChange }) => {
//   return (
//     <TextField
//       fullWidth
//       variant="outlined"
//       size="small"
//       placeholder={placeholder || "Search..."}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       InputProps={{
//         startAdornment: (
//           <InputAdornment position="start">
//             <SearchIcon style={{ color: "gray" }} />
//           </InputAdornment>
//         ),
//       }}
//       sx={{
//         mb: 2,
//         backgroundColor: (theme) =>
//           theme.palette.mode === "dark" ? "grey.800" : "white",
//       }}
//     />
//     <TextField
//   fullWidth
//   variant="outlined"
//   size="small"
//   placeholder={placeholder || "Search..."}
//   value={value}
//   onChange={(e) => onChange(e.target.value)}
//   InputProps={{
//     startAdornment: (
//       <InputAdornment position="start">
//         <SearchIcon sx={{ color: 'gray.500' }} />
//       </InputAdornment>
//     ),
//     sx: {
//       pl: 1.5, // equivalent to pl-10 (adjusted for icon)
//       pr: 1.5,
//       py: 1,
//       borderRadius: 1.5,
//       bgcolor: 'white',
//       color: 'text.primary',
//       '&::placeholder': {
//         color: 'gray.500',
//         opacity: 1,
//       },
//     },
//   }}
//   sx={{
//     mb: 2,
//     border: '1px solid',
//     borderColor: 'grey.300',
//     borderRadius: 2,
//     backgroundColor: (theme) =>
//       theme.palette.mode === 'dark' ? 'grey.800' : 'white',
//     '& .MuiOutlinedInput-root': {
//       '& fieldset': {
//         borderColor: (theme) =>
//           theme.palette.mode === 'dark' ? 'grey.600' : 'grey.300',
//       },
//       '&:hover fieldset': {
//         borderColor: 'primary.main',
//       },
//       '&.Mui-focused fieldset': {
//         borderColor: 'primary.main',
//         borderWidth: 1,
//       },
//       color: (theme) =>
//         theme.palette.mode === 'dark' ? 'white' : 'inherit',
//     },
//     '& input::placeholder': {
//       color: 'grey.500',
//     },
//   }}
// />

//   );
// };

// export default SearchBar;

// components/SearchBar.tsx
// import React, { FormEvent } from "react";
// import { TextField, IconButton, InputAdornment } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";

// interface SearchBarProps {
//   placeholder?: string;
//   value: string;
//   onChange: (value: string) => void;
//   onSubmit?: () => void; // Optional submit handler
//   label?: string;
// }

// const SearchBar: React.FC<SearchBarProps> = ({
//   placeholder = "Search...",
//   value,
//   onChange,
//   onSubmit,
//   label = "Search",
// }) => {
//   const handleSubmit = (e: FormEvent) => {
//     e.preventDefault();
//     onSubmit?.(); // Call parent submit function if provided
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <TextField
//         fullWidth
//         size="small"
//         variant="outlined"
//         label={label}
//         placeholder={placeholder}
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         InputProps={{
//           endAdornment: (
//             <InputAdornment position="end">
//               <IconButton type="submit" aria-label="search">
//                 <SearchIcon style={{ fill: "blue" }} />
//               </IconButton>
//             </InputAdornment>
//           ),
//         }}
//         sx={{
//           mb: 2,
//           backgroundColor: (theme) =>
//             theme.palette.mode === "dark" ? "grey.800" : "white",
//           '& .MuiOutlinedInput-root': {
//             borderRadius: 2,
//             '& fieldset': {
//               borderColor: (theme) =>
//                 theme.palette.mode === 'dark' ? 'grey.600' : 'grey.300',
//             },
//             '&:hover fieldset': {
//               borderColor: 'primary.main',
//             },
//             '&.Mui-focused fieldset': {
//               borderColor: 'primary.main',
//             },
//           },
//           '& input::placeholder': {
//             color: 'grey.500',
//           },
//         }}
//       />
//     </form>
//   );
// };

// export default SearchBar;


// components/SearchBar.tsx
// import React from "react";
// import { InputAdornment, TextField } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";

// interface SearchBarProps {
//   placeholder?: string;
//   value: string;
//   onChange: (value: string) => void;
// }

// const SearchBar: React.FC<SearchBarProps> = ({ placeholder, value, onChange }) => {
//   return (
//     <TextField
//       fullWidth
//       id="search-bar"
//       variant="outlined"
//       size="small"
//       placeholder={placeholder || "Search..."}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       InputProps={{
//         startAdornment: (
//           <InputAdornment position="start">
//             <SearchIcon style={{ color: "gray" }} />
//           </InputAdornment>
//         ),
//       }}
//       sx={{
//         mb: 2,
//         backgroundColor: (theme) =>
//           theme.palette.mode === "dark" ? "grey.800" : "white",
//       }}
//     />
//   );
// };

// export default SearchBar;


import React from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void; // Pass the event object
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder, value, onChange }) => {
  return (
    <TextField
      fullWidth
      id="search-bar"
      variant="outlined"
      size="small"
      placeholder={placeholder || "Search..."}
      value={value}
      onChange={onChange} // Pass the event object directly
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon style={{ color: "gray" }} />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton
              onClick={() =>
                onChange({ target: { value: "" } } as React.ChangeEvent<HTMLInputElement>)
              }
              size="small"
              edge="end"
            >
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        mb: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === "dark" ? "gray.800" : "white",
      }}
    />
  );
};

export default SearchBar;